<template>
  <main>
    <section class="jm-text-center jm-py-4 jm-px-2">
      <header-stylist-selection>
        <h1 class="jm-uppercase jm-mb-3">Échange avec une Styliste</h1>
        <div v-if="possibleSponsors.length">
          <p class="jm-mb-3 jm-px-3">
            Voici 3 profils de Stylistes qui te correspondent le plus.
            Sélectionne un profil pour être mis en contact et poser toutes tes
            questions.
          </p>
          <router-link
            class="jm-link jm-text-underline"
            :to="{ name: 'contactForm' }"
          >
            Je modifie mes infos
          </router-link>
        </div>
        <p v-else>
          Nous ne pouvons pas vous proposer de Styliste. L'équipe du siège peut
          répondre à vos questions.
          <base-cta
            :text="footerText"
            :label="footerLabelButton"
            :url="urlCtaWebinar"
          ></base-cta>
        </p>
      </header-stylist-selection>
    </section>

    <section
      class="stylist-cards-container jm-bg-background-secondary"
      v-if="possibleSponsors.length"
    >
      <div
        class="jm-pb-4"
        v-for="(possibleSponsor, possibleSponsorIndex) in possibleSponsors"
        :key="possibleSponsor.customerId"
      >
        <stylist-profile-card
          :stylist="possibleSponsor"
          :resultIndex="Number(possibleSponsorIndex) + 1"
          data-test="stylist-profile-card"
        ></stylist-profile-card>
      </div>
    </section>

    <footer-stylist
      v-if="possibleSponsors.length"
      :text="footerText"
      :labelButton="footerLabelButton"
    />
  </main>
</template>
<script>
import * as store from '@/store/store'
import BaseCTA from '@/components/molecules/BaseCTA.vue'
import FooterStylist from '@/components/organisms/FooterStylist.vue'
import HeaderStylistSelection from '@/components/organisms/HeaderStylistSelection.vue'
import StylistProfileCard from '@/components/organisms/StylistProfileCard.vue'

const FOOTER_TEXT =
  'Tu préfères échanger avec l’équipe du siège directement ?<br /> Participe à une réunion en ligne.'
const FOOTER_LABEL_BUTTON = 'Je réserve un créneau'
const URL_CTA_WEBINAR =
  'https://app.livestorm.co/beauty-blend/devenir-styliste-beaute-jolimoi?type=light'

export default {
  name: 'StylistSelectionView',
  components: {
    StylistProfileCard,
    FooterStylist,
    HeaderStylistSelection,
    'base-cta': BaseCTA
  },
  data() {
    return {
      possibleSponsors: [],
      prospectId: '',
      footerText: FOOTER_TEXT,
      footerLabelButton: FOOTER_LABEL_BUTTON,
      urlCtaWebinar: URL_CTA_WEBINAR
    }
  },
  async created() {
    this.loadResults()
  },
  methods: {
    loadResults() {
      this.possibleSponsors = store.getPossibleSponsors()
    }
  }
}
</script>

<style lang="scss" scoped>
.stylist-cards-container {
  padding: $spacing-4;
  padding-bottom: 0;
}
</style>
